<template>
  <el-form-item v-if="handleCondition()&&showInEditOrAdd"
                :label="`${config.label}：`"
                :prop="config.prop">
    <component :is="config.type"
               :context="context"
               :config="config"></component>
  </el-form-item>
</template>

<script>
const files = require.context(
  "../q_componts",
  false,
  /\be_(?!router|add).*\.vue/
);
const allComponent = {};
files.keys().forEach(element => {
  allComponent[files(element).default.name] = files(element).default;
});

import { PIC_API as picAPI } from "@/utils/common";

export default {
  name: "ERouter",
  components: allComponent,

  // functional: true,
  // Props 是可选的
  props: ["config", "context",'customProp'],
  data() {
    return {
      picAPI
    };
  },
  watch: {
    "config.require"() {
      this.handleRequire();
    }
  },
  computed: {
    showInEditOrAdd() {
      const { type } = this.context;
      if (type == "add") {
        return this.config.showAdd;
      } else {
        return this.config.showEdit;
      }
    }
  },
  created() {
    this.handleDefaultValue();
  },
  mounted(){
    this.$nextTick().then(()=>{

      this.handleRequire();
    })


  },
  methods: {
    handleCondition() {
      if (!this.config.needCondition) {
        return true;
      } else {
        try {
          let v = false;
          v = Function(
            "context",
            `with(context.ruleForm){
              return   (${this.config.condition} )
            }`
          )(this.context);
          return v;
        } catch (e) {
          console.log("conditon -> e", e);
          return false;
        }
      }
    },
    handleRequire() {
      const { require, prop, label } = this.config;
      if (require && !this.context.rules[prop]) {
        let rule = [
          {
            required: true,
            message: `请输入或选择${label}`,
            trigger: "change"
          }
        ];
        this.$set(this.context.rules, prop, rule);
      } else if (!require && this.context.rules[prop]) {
        this.$set(this.context.rules, prop, null);
      }
    },
    handleDefaultValue() {
      const { prop, defaultValue } = this.config;
      if (!this.context.ruleForm[prop]) {
        if (defaultValue.startsWith("[") || defaultValue.startsWith("{")) {
          this.$set(this.context.ruleForm, prop, JSON.parse(defaultValue));
        } else {
          this.$set(this.context.ruleForm, prop, defaultValue);
        }
      }
    }
  }
};
</script>
